import { Injectable, TemplateRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class FrontendDialogService extends MatDialog {
  open<T>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig): MatDialogRef<T> {
    // Override with custom config
    const customConfig: MatDialogConfig = {
      panelClass: ['modalPane', 'appModal'],
      backdropClass: 'modalBackdrop',
      autoFocus: false
    };

    // If config is passed in, assign with custom config.
    if (config) {
      Object.assign(customConfig, config);
    }

    return super.open(componentOrTemplateRef, customConfig);
  }
}
